<ng-container>
  <div class="col approval-container">
    <div class="row">
      <div class="col-md-3">
        {{approval.projectInstallmentFundingConditionApprovalType.name}}
      </div>
      <div class="col-md-3">
        @if (permissions?.approvalPermissions?._edit) {
          <select [formControl]="statusFormControl">
            <option [value]="null">--</option>
            @for (status of statuses; track status) {
              <option [value]="status.id">{{status.name}}</option>
            }
          </select>
        }
        @if (!permissions?.approvalPermissions?._edit) {
          {{readOnlyStatus.length > 0 ? readOnlyStatus : '--'}}
        }
      </div>
      @if (approval.user!==null) {
        <div class="col-md-2">
          {{approval.user.person?.name}}
        </div>
      }
      @if (approval.user==null) {
        <div class="col-md-2">
          --
        </div>
      }
      <div class="col-md-4">
        <div class="row date-action">
          <div class="col-md-11">
            {{approval.approval_status_date | date : 'yyyy-MM-dd'}}
          </div>
          <div class="col-md-1">
            @if (!readonly && permissions?.approvalPermissions?._delete) {
              <div class="remove-approval-button" matTooltip="Remove approval">
                <i class="material-icons" style="font-size: 16px" (click)="openDeleteConfirmationModal()">close</i>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
